import React, { useState } from "react";
import "../assets/css/AarambhGallery.css";

import img1 from '../assets/Gallery/aarambh1.jpg';
import img2 from '../assets/Gallery/aarambh2.jpg';
import img3 from '../assets/Gallery/aarambh3.jpg';
import img4 from '../assets/Gallery/aarambh4.jpg';
import img5 from '../assets/Gallery/aarambh5.jpg';
import img6 from '../assets/Gallery/aarambh6.jpg';

const images = [
    { src: img1, title: "Opening Session at AARAMBH" },
    { src: img2, title: "Packed Learning Hall" },
    { src: img3, title: "Expert-Led Knowledge Sharing" },
    { src: img4, title: "Expert-Led Knowledge Sharing" },
    { src: img5, title: "Live Networking Moments" },
    { src: img6, title: "Expert-Led Knowledge Sharing" },
];

const AarambhGallery = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const closeModal = () => setActiveIndex(null);
    const next = () => setActiveIndex((prev) => (prev + 1) % images.length);
    const prev = () =>
        setActiveIndex((prev) => (prev - 1 + images.length) % images.length);

    return (
        <>
            <section className="aarambh-gallery-section">
                {/* HEADER */}
                <div className="aarambh-gallery-header">
                    <h2>AARAMBH in Action</h2>
                    <p>
                        Real Estate Learning & Networking | The Pride Hotel, Pune | 24 July
                        2025
                    </p>
                </div>

                {/* MASONRY GRID */}
                <div className="aarambh-masonry">
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className="aarambh-item"
                            onClick={() => setActiveIndex(index)}
                        >
                            <img src={img.src} alt={img.title} />
                            <div className="aarambh-overlay">
                                <span>{img.title}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* LIGHTBOX SLIDER */}
            {activeIndex !== null && (
                <div className="aarambh-lightbox">
                    <span className="aarambh-close" onClick={closeModal}>×</span>

                    <button className="aarambh-nav left" onClick={prev}>‹</button>

                    <div className="aarambh-lightbox-content">
                        <img src={images[activeIndex].src} alt="" />
                        <p>{images[activeIndex].title}</p>
                    </div>

                    <button className="aarambh-nav right" onClick={next}>›</button>
                </div>
            )}
        </>
    );
};

export default AarambhGallery;
